import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle,Button } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  dataEntryExpressOutward,
  getExpressInwardApi,
  getPartyApi,
  getUnitAPI,
  getUserApi,
} from "api";
import AsyncSelect from "react-select/async";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";
import OutwardFormModal from "components/Common/OutwardFormModal";
import {
  outWardStatus,
} from "components/sales-office/ExpressInwardList";
const DateFilter = [
  { label: "Entry Date", value: "entrydate" },
  { label: "Last Outward Date", value: "lastoutwarddate" },
];
class DataEntryExpressInwardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 100,
      totalSize: 10,
      selectedPartyDetails: null,
      partyId: "",
      factoryId: "",
      jangadId: "",
      outWardStatus: "",
      dateFilterType: "",
      fromDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      factoryList: [],
      orderList: [],
      stockList: [],
      partyList: [],
      deliveryBoyList: [],
      scannedBarcode: "",
    };
    this.openOutwardModal = this.openOutwardModal.bind(this);
    this.closeOutwardModal = this.closeOutwardModal.bind(this);
  }
  async componentDidMount() {
    this.setState(
      {
        partyId: localStorage.getItem("data_entry_filter_partyId") || "",
        fromDate:
          localStorage.getItem("data_entry_filter_fromDate") ||
          moment().subtract(6, "days").format("YYYY-MM-DD"),
        toDate:
          localStorage.getItem("data_entry_filter_toDate") ||
          moment().format("YYYY-MM-DD"),
        jangadId: localStorage.getItem("data_entry_filter_jangadId") || "",
        outWardStatus:
          localStorage.getItem("data_entry_filter_outWardStatus") || "",
        factoryId: localStorage.getItem("data_entry_filter_factoryId") || "",
        dateFilterType:
          localStorage.getItem("data_entry_dateFilterType") || "",
      },
      () => this.getStockList()
    );

    const deliveryBoy = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000006",
    });
    this.setState({
      deliveryBoyList: deliveryBoy.data.users,
    });
    const partyList = await getPartyApi({});
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    } else {
      this.setState({ partyList: [] });
    }
    const factoryList = await getUnitAPI({
      isInternal: null,
      name: null,
      page: 1,
      limit: 10,
    });
    if (
      factoryList &&
      factoryList.data &&
      Array.isArray(factoryList.data.factories)
    ) {
      this.setState({
        factoryList: factoryList.data.factories,
      });
    }
    await this.getJangadList(null, this.state.partyId);
    const jangadList = await getExpressInwardApi({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      jangadId: this.state.jangadId,
      factoryId: this.state.factoryId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
    if (jangadList && jangadList.data) {
      this.setState({
        totalSize: jangadList.data.count || 0,
        stockList:
          Array.isArray(jangadList.data.expressInwards) &&
          jangadList.data?.expressInwards?.length > 0
            ? jangadList.data.expressInwards
            : [],
      });
    }

    this.getStockList();
  }
  setParty = value => {
    this.setState({
      selectedPartyDetails: value,
    });
  };
  async getStockList() {
    const stockList = await getExpressInwardApi({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      jangadId: this.state.jangadId,
      factoryId: this.state.factoryId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      outWardStatus: this.state.outWardStatus,
      dateFilterType: this.state.dateFilterType,
    });
    if (stockList.data)
      this.setState({
        totalSize: stockList.data.count,
        stockList:
          Array.isArray(stockList.data.expressInwards) &&
          stockList.data.expressInwards.length === 0
            ? []
            : Array.isArray(stockList.data.expressInwards)
            ? stockList.data.expressInwards
            : [],
      });
  }
  async getFactoryList(inputValue) {
    const data = await getUnitAPI({
      isInternal: null,
      name: null,
      page: null,
      limit: null,
    });
    if (data && data.data && Array.isArray(data.data.factories)) {
      this.setState({
        factoryList: data.data.factories,
      });
      const allFactories = data.data.factories;
      const filtered = inputValue
        ? allFactories.filter(factory =>
            (factory.name || "")
              .toLowerCase()
              .includes(inputValue.toLowerCase())
          )
        : allFactories;
      return filtered.map(factory => ({
        label: factory.name,
        value: factory.id,
      }));
    }
    return this.state.factoryList.map(x => {
      return { label: x.name, value: x.id };
    });
  }
  formatPartyCode = code => {
    if (!code) return "";
    const cleaned = code.replace(/^PARTY/i, "");
    const numeric = Number(cleaned);
    if (!isNaN(numeric)) {
      return numeric.toString().padStart(3, "0");
    }
    return cleaned;
  };
  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });

    const parties = Array.isArray(data.data.parties) ? data.data.parties : [];

    this.setState({
      partyList: parties,
    });

    const filtered = parties.filter(x => {
      const codeNum = (this.formatPartyCode(x.partyCode) || "").toLowerCase();
      return codeNum.includes(inputValue);
    });

    return filtered.map(x => {
      const codeNum = (this.formatPartyCode(x.partyCode) || "").toLowerCase();
      return { label: codeNum, value: x.id };
    });
  }

  async getJangadList(inputValue, partyId = null) {
    const data = await getExpressInwardApi({
      page: null,
      limit: null,
      name: null,
    });
    if (data && data.data && Array.isArray(data.data.expressInwards)) {
      const allOptions = data.data.expressInwards.map(x => ({
        label: x.jangadId,
        value: x.jangadId,
      }));

      const filteredOptions = inputValue
        ? allOptions.filter(opt =>
            opt.label.toLowerCase().includes(inputValue.toLowerCase())
          )
        : allOptions;

      const finalOptions = inputValue
        ? filteredOptions
        : [{ label: "All", value: "" }, ...filteredOptions];

      this.setState({ orderList: finalOptions }); // optional if you need to cache
      return finalOptions;
    }
    return [{ label: "All", value: "" }];
  }
  openOutwardModal(row) {
    this.setState({ outwardModalOpen: true, outwardModalRow: row });
  }
  closeOutwardModal() {
    this.setState({ outwardModalOpen: false, outwardModalRow: null });
  }
   resetAll = async () => {
      // Clear localStorage filter values
      localStorage.removeItem("data_entry_filter_partyId");
      localStorage.removeItem("data_entry_filter_fromDate");
      localStorage.removeItem("data_entry_filter_toDate");
      localStorage.removeItem("data_entry_filter_jangadId");
      localStorage.removeItem("data_entry_filter_outWardStatus");
      localStorage.removeItem("data_entry_filter_factoryId");
      localStorage.removeItem("data_entry_dateFilterType");
  
      // Reset state to defaults
      await this.setState(
        {
          partyId: "",
          jangadId: "",
          factoryId: "",
          outWardStatus: "",
          dateFilterType: null,
          fromDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
          scannedBarcode: "",
          page: 1,
          sizePerPage: 100,
          stockList: [],
        },
        () => this.getStockList()
      );
    };
  
    // Refresh list without clearing filters or barcode input
    refreshList = async () => {
      this.setState(
        {
          stockList: [],
          page: 1,
        },
        () => this.getStockList()
      );
    };
    handleBarcodeScan = async e => {
      const scannedValue = e.target.value.trim();
      this.setState({ scannedBarcode: scannedValue });
  
      if (scannedValue) {
        const stockList = this.state.stockList;
        const matchedInward = stockList.find(
          item => `JANGAD${item.id}` === scannedValue
        );
        if (matchedInward) {
          setTimeout(() => {
            this.props.history.push({
              pathname: "/view-express-inward",
              query: { data: matchedInward },
            });
          }, 1000); // 1-second delay 
        } else {
          // alert(`Invalid barcode: ${scannedValue}. No matching inward found.`);
        }
      }
    };
  
  render() {
    const formatNumber = num => {
      if (num == null) return "0";
      return Number.isInteger(num) ? num : Number(num).toFixed(2);
    };

    // Calculate totals for footer
    const calculateTotals = () => {
      let totalPieces = 0;
      let totalWeight = 0;
      let remainingPiecesTotal = 0;
      let remainingWeightTotal = 0;

      this.state.stockList.forEach(item => {
        totalPieces += Number(item.noOfPieces) || 0;
        totalWeight += Number(item.totalWeight) || 0;

        // Calculate remaining pieces and weight
        const returnPieces = item.returnPieces + item.outwardPieces || 0;
        const returnWeight = item.returnWeight + item.outwardWeight || 0;
        const remainingPieces = (Number(item.noOfPieces) || 0) - returnPieces;
        const remainingWeight = (Number(item.totalWeight) || 0) - returnWeight;

        remainingPiecesTotal += remainingPieces;
        remainingWeightTotal += remainingWeight;
      });

      return {
        totalPieces: totalPieces,
        totalWeight: formatNumber(totalWeight),
        remainingPieces: remainingPiecesTotal,
        remainingWeight: formatNumber(remainingWeightTotal),
      };
    };

    const totals = calculateTotals();

    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue));
        }, 0);
      });
    const promiseOptionsFactory = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getFactoryList(inputValue));
        }, 0);
      });
    this.columns1 = [
      {
        dataField: "sr",
        text: "#",
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return (this.state.page - 1) * this.state.sizePerPage + rowIndex + 1;
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
        footer: () => {
          return <div></div>;
        },
      },

      {
        dataField: "action",
        text: `${this.props.t("Action")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            {row.noOfPieces -
              (row?.noOfReturnedPiecesWithoutProcessed + row?.outwardPieces) >
              0 &&
              row.status !== "Pending" &&
              row.status !== "Closed" && (
                <button
                  className="py-2 px-2 border-0 rounded"
                  onClick={() => this.openOutwardModal(row)}
                  type="button"
                >
                  Outward
                </button>
              )}
            <Link
              to={{
                pathname: "/view-express-inward",
                query: {
                  data: row,
                },
              }}
            >
              <button className="py-2 px-2 ms-2 border-0 rounded">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
        footer: () => {
          return <div></div>;
        },
      },

      {
        dataField: "mainJangadId",
        text: `${this.props.t("J. Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.jangadId;
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("P. Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return this.formatPartyCode(row.party?.partyCode);
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "totalPieces",
        text: `${this.props.t("T. Pcs")}`,
        sort: true,
        formatter: (cell, row) => {
          const totalPieces = row.noOfPieces || 0;
          const returnPieces = row.returnPieces + row.outwardPieces || 0;
          const remainingPieces = totalPieces - returnPieces;
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ "margin-right": "5px" }}>{row.noOfPieces}</div>
              <div className="text-success">({remainingPieces || 0})</div>
            </div>
          );
        },
        footer: () => {
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ marginRight: "5px" }}>
                T. Pcs: {totals.totalPieces}
              </div>
              <div className="text-success">({totals.remainingPieces})</div>
            </div>
          );
        },
      },
      {
        dataField: "totalWeight",
        text: `${this.props.t("T. Weight")}`,
        sort: true,
        formatter: (cell, row) => {
          const totalWeight = formatNumber(row.totalWeight) || 0;
          const returnWeight = row.returnWeight + row.outwardWeight || 0;
          const remainingWeight = totalWeight - returnWeight;
          const formattedRemaining = formatNumber(remainingWeight);
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ "margin-right": "5px" }}>{totalWeight}</div>
              <div className="text-success">({formattedRemaining || 0})</div>
            </div>
          );
        },
        footer: () => {
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ marginRight: "5px" }}>
                T. Weight: {totals.totalWeight}
              </div>
              <div className="text-success">({totals.remainingWeight})</div>
            </div>
          );
        },
      },
      {
        dataField: "status",
        text: `${this.props.t("Status")}`,
        sort: true,
        formatter: (cell, row) => row.status,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "outwardPiecesWeight",
        text: `${this.props.t("D. Pcs./D. Weight")}`,
        sort: true,
        formatter: (cell, row) =>
          `${row.outwardPieces} / ${formatNumber(row.outwardWeight)}`,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "lastDeliveredYet",
        text: `${this.props.t("D. Date/Time")}`,
        sort: true,
        formatter: (cell, row) =>
          row.LastDeliveredYet
            ? moment(row.LastDeliveredYet).format("DD/MM/YYYY - hh:mm:ss")
            : "",
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "salesRemark",
        text: `${this.props.t("Sales Remark")}`,
        sort: true,
        formatter: (cell, row) => row.salesRemark,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "returnPcsWeight",
        text: `${this.props.t("Return pcs.")}`,
        sort: true,
        formatter: (cell, row) => row.noOfReturnedPiecesWithoutProcessed,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "inProcessPieces",
        text: `${this.props.t("In Process Pcs.")}`,
        sort: true,
        formatter: (cell, row) => row.dataEntryInprocess,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        sort: true,
        formatter: (cell, row) => row.category?.name,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        sort: true,
        formatter: (cell, row) => row.cycle,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "entryDate",
        text: `${this.props.t("Entry Date")}`,
        sort: true,
        formatter: (cell, row) => moment(row.createdAt).format("DD/MM/YYYY"),
        footer: () => {
          return <div></div>;
        },
      },
    ];
    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
              style={{ color: "red" }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
      sizePerPage: this.state.sizePerPage,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "manage stock";
    const remainingPieces =
      this.state.outwardModalRow?.noOfPieces -
      (this.state.outwardModalRow?.noOfReturnedPiecesWithoutProcessed +
        this.state.outwardModalRow?.outwardPieces);

    const rowClasses = (row, rowIndex) => {

      const endTime = row.completedAt ? new Date(row.completedAt) : new Date();

      const startTime = new Date(row.createdAt);
      const durationMs = endTime - startTime; // difference in ms
      const durationHours = durationMs / (1000 * 60 * 60); // convert ms to hours

      if (durationHours > 36) return "red-bg";
      if (durationHours > 24) return "yellow-bg";
      return "";
    };
    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {`${this.props.t("Express - INWARD")}`}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="">
                              <h3 className="text-black fw-bold">
                                {this.props.t("Express Inward List")}{" "}
                              </h3>
                            </div>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="col-md-3 col-12">
                                <div className="d-flex flex-column flex-md-row align-items-center align-items-md-center">
                                  {/* Label */}
                                  <label
                                    htmlFor="dateFilterType"
                                    className="fs-5 pe-2 mb-2 mb-md-0"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    {this.props.t("Filter Date")}
                                  </label>

                                  {/* Dropdown */}
                                  <Select
                                    aria-labelledby="aria-label"
                                    className="officestock-select d-inline-block"
                                    inputId="aria-example-input"
                                    name="aria-live-color"
                                    onMenuOpen={this.onMenuOpen}
                                    onMenuClose={this.onMenuClose}
                                    value={DateFilter.find(option => option.value === this.state.dateFilterType) || null}
                                    onChange={e => {
                                      const value = e.value;

                                      localStorage.setItem(
                                        "data_entry_filter_dateFilterType",
                                        value
                                      );
                                      this.setState(
                                        {
                                          dateFilterType: value,
                                          stockList: [],
                                          page: 1,
                                        },
                                        () => this.getStockList()
                                      );
                                    }}
                                    options={DateFilter}
                                  />
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="fromDate"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e => {
                                    localStorage.setItem(
                                      "data_entry_filter_fromDate",
                                      e.target.value
                                    );
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    );
                                  }}
                                />
                                <label
                                  htmlFor="toDate"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e => {
                                    localStorage.setItem(
                                      "data_entry_filter_toDate",
                                      e.target.value
                                    );
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    );
                                  }}
                                />
                              </div>

                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between mt-2">
                              
                            <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Party")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      value={
                                        this.state.partyList
                                          .map((x, i) => ({
                                            value: x.id,
                                            label: `${this.formatPartyCode(
                                              x.partyCode
                                            )}`,
                                          }))
                                          .find(
                                            x => x.value === this.state.partyId
                                          ) || { label: "All", value: "" }
                                      }
                                      onChange={e => {
                                        localStorage.setItem(
                                          "data_entry_filter_partyId",
                                          e.value
                                        );
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 100,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: `${this.formatPartyCode(
                                              x.partyCode
                                            )}`,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="d-block mx-auto d-sm-inline pe-0 pe-sm-2">
                                  {" "}
                                  <input
                                    readOnly
                                    defaultValue={
                                      this.state.partyList.filter(
                                        x => x.id == this.state.partyId
                                      ).length
                                        ? this.state.partyList.filter(
                                            x => x.id == this.state.partyId
                                          )[0].contactPersonName
                                        : ""
                                    }
                                    type="text"
                                    placeholder="Contact Person"
                                    className="form-gray ps-2 mb-2 mb-md-0 py-2"
                                  />
                                </div>
                                <div className="mx-auto d-block d-sm-inline">
                                  <input
                                    readOnly
                                    defaultValue={
                                      this.state.partyList.filter(
                                        x => x.id == this.state.partyId
                                      ).length
                                        ? this.state.partyList.filter(
                                            x => x.id == this.state.partyId
                                          )[0].mobileNo1
                                        : ""
                                    }
                                    type="number"
                                    onWheel={e => e.target.blur()}
                                    placeholder="Mobile No."
                                    className="form-gray  py-2 ps-2"
                                  />
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      value={
                                        this.state.orderList.find(
                                          option =>
                                            option.value === this.state.jangadId
                                        ) || null
                                      }
                                      onChange={async e => {
                                        localStorage.setItem(
                                          "data_entry_filter_jangadId",
                                          e.value
                                        );
                                        await this.setState({
                                          jangadId: e.value,
                                          stockList: [],
                                          page: 1,
                                          sizePerPage: 100,
                                        });
                                        this.getStockList();
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={this.state.orderList}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Outward Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    localStorage.setItem(
                                      "data_entry_filter_outWardStatus",
                                      e.value
                                    );
                                    this.setState(
                                      {
                                        outWardStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 100,
                                      },
                                      () => {
                                        this.getStockList().then(() => {});
                                      }
                                    );
                                  }}
                                  value={outWardStatus.find(
                                    option =>
                                      option.value === this.state.outWardStatus
                                  )}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={outWardStatus}
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="barcodeInput"
                                  className="pt-2 fs-5 pe-1 pe-lg-3 mb-2 mb-md-0"
                                >
                                  {this.props.t("Scan Barcode")}
                                </label>

                                <input
                                  type="text"
                                  id="barcodeInput"
                                  className="form-gray ps-2 mb-2 mb-md-0 py-2"
                                  value={this.state.scannedBarcode}
                                  onChange={this.handleBarcodeScan}
                                  onKeyDown={e => {
                                    if (e.key === "Enter") {
                                      this.handleBarcodeScan(e);
                                    }
                                  }}
                                  placeholder=""
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Unit")}
                                    </label>
                                    <AsyncSelect
                                      id="factoryId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        localStorage.setItem(
                                          "data_entry_filter_factoryId",
                                          e.value
                                        );
                                        this.setState(
                                          {
                                            factoryId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 100,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      value={[
                                        { label: "All", value: "" },
                                        ...this.state.factoryList.map(x => ({
                                          value: x.id,
                                          label: x.name,
                                        })),
                                      ].find(
                                        option =>
                                          option.value === this.state.factoryId
                                      )}
                                      loadOptions={promiseOptionsFactory}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.factoryList.map(x => {
                                          return { value: x.id, label: x.name };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Row className="mb-3 g-2">
                              <Col xs={12} sm={6} md={2}>
                                <Button
                                  className="w-100 fs-5 py-2"
                                  color="primary"
                                  onClick={this.refreshList}
                                >
                                  {this.props.t("Refresh")}
                                </Button>
                              </Col>
                              <Col xs={12} sm={6} md={2}>
                                <Button
                                  className="w-100 fs-5 py-2"
                                  color="primary"
                                  onClick={this.resetAll}
                                >
                                  {this.props.t("Reset")}
                                </Button>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    data={this.state.inwordStockList}
                                    columns={this.columns1}
                                    rowClasses={rowClasses}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    onTableChange={() => false}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}{" "}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
                <OutwardFormModal
                  isOpen={this.state.outwardModalOpen}
                  toggle={this.closeOutwardModal}
                  deliveryBoyList={this.state.deliveryBoyList}
                  remainingPieces={remainingPieces || 0}
                  t={this.props.t}
                  onSubmit={async values => {
                    const payload = {
                      inwardId: this.state.outwardModalRow?.id,
                      deliveryBoyName: values.deliveryBoy,
                      noOfPieces: values.piecesToDeliver,
                      totalWeight: values.totalWeight,
                      remark: values.remark,
                      isProcessed: true,
                    };
                    try {
                      const outwards = await dataEntryExpressOutward(payload);
                      if (outwards?.success === true) {
                        this.setState({ outwardModalOpen: false });
                        this.getStockList();
                      } else {
                        console.warn(
                          "Accept & Return API did not return success:",
                          accept.message
                        );
                      }
                    } catch (err) {
                      console.error("Error submitting outward:", err);
                    }
                  }}
                  initialValues={{
                    piecesToDeliver: "",
                    totalWeight: "",
                    remark: "",
                    deliveryBoy: "",
                  }}
                />
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(DataEntryExpressInwardList);
